<template>
  <section>
    <ui-ask-danger ref="ask"/>
    <div class="rounded-lg bg-white shadow">

      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <div class="md:flex md:items-center md:justify-between">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900"> Список мероприятий
            </h3>
            <p class="mt-2 max-w-4xl text-sm text-gray-500">
              Добавление, редактирование мероприятий, модерирование заявок на мероприятия.
            </p>
          </div>

          <div class="mt-3 flex md:mt-0  md:top-3 md:right-0">
            <!--            <router-link :to="{name: 'EventEditAbout', params:{id: 'new'}}">-->
            <ui-button @click="create_new()">Создать</ui-button>
            <!--            </router-link>-->
          </div>
        </div>

        <ui-filter-dropdown v-model="filter" v-model:queryStr="queryStr" :filters="filters" :search="true"
                            class="mt-4"/>

        <ui-table :rows="events.data">
          <ui-table-col prop="index" label="#" :from="events.from"/>
          <ui-table-col label="Информация">
            <template #default="{row}">
              <div class="flex items-center">
                <div>
                  <div class="text-md text-gray-700">
                    <router-link class="link" :to="{name: 'EventEditAbout', params: {id: row.id ?? 1}}">
                      {{ row.name ?? 'Мероприятие #' + row.id }}
                    </router-link>
                  </div>
                  <div class="text-sm text-gray-500">
                    <a href="#" class="mr-3">заявки (0)</a>
                    <!--                    <a href="#" class="mr-3">участники (0)</a>-->
                    <!--                    <a href="#" class="mr-3">кураторы (0)</a>-->
                    <!--                        <a href="#" class="mr-3 link">координаторы (0)</a>-->
                    <!--                            <a href="#" class="mr-3 link text-red-700"> [удалить файлы]</a>-->

                  </div>
                </div>
              </div>
            </template>
          </ui-table-col>
          <ui-table-col label="Время проведения">
            <template #default="{row}">
              <div class="flex items-center">
                <div class="text-sm text-gray-500">
                  <p>Регистрация: {{ row.started_reg_at }} </p>
                  <p>Проведение: {{ row.started_at }} - {{ row.ended_at }} </p>
                </div>
              </div>
            </template>
          </ui-table-col>
          <ui-table-col label="Статус">
            <template #default="{row}">
              <ui-badge v-if="row.published_at" color="green">опубликовано</ui-badge>
              <ui-badge v-else color="yellow">не опубликовано</ui-badge>
            </template>

          </ui-table-col>
          <ui-table-col label="" class="text-right">
            <template #default="{row}">
              <ui-dropdown-actions :actions=" row.published_at ? actions_pub : actions" @ok="cmd =>{action(cmd, row)}"/>
            </template>
          </ui-table-col>
        </ui-table>

        <ui-pagination @change="paginate" query_param="page" :from="events.from" :to="events.to"
                       :total="events.total" :current="events.current_page" :last="events.last_page"/>
      </div>

    </div>
  </section>
</template>

<script>
import UiPagination from "@/components/ui/UiPagination";
import UiButton from "@/components/ui/button/UiButton";

import UiDropdownActions from "@/components/ui/dropdown/UiDropdownActions";
import UiTable from "@/components/ui/table/UiTable";
import UiTableCol from "@/components/ui/table/UiTableCol";
import UiBadge from "@/components/ui/elements/badges/UiBadge";
import UiAskDanger from "@/components/ui/ask/UiAskDanger";
import UiFilterDropdown from "@/components/ui/filters/UiFilterDropdown";

const filters = [{
  name: 'Статус',
  id: 'status',
  array_query: true,
  options: [
    {name: 'Опубликовано', id: 'published'},
    {name: 'Не опубликовано', id: 'created'},
   /* {name: 'Завершено', id: 'ended'},*/
  ]
}
]

export default {
  name: "EventsAdmin",
  components: {
    UiFilterDropdown,
    UiAskDanger,
    UiBadge,
    UiTableCol,
    UiTable,
    UiDropdownActions,
    UiButton,
    UiPagination
  },
  setup() {
    return {filters}
  },
  data() {
    return {
      search: '',
      events: {data: [{}]},
      filter: {},
      queryStr: '',
      actions: ['edit', 'publish', '-', 'remove'],
      actions_pub: ['edit', '-', 'cancel_publish']
    }
  },
  methods: {
    async create_new() {
      const event = await this.$api.events.post()
      this.$router.push({name: 'EventEditAbout', params: {id: event.id}})
    },
    async paginate(page) {
      this.events = await this.$api.events.paginate(page, this.queryStr)
    },
    action(cmd, event) {
      switch (cmd) {
        case 'edit':
          this.$router.push({name: 'EventEditAbout', params: {id: event.id}})
          break;
        case 'remove':
          this.$refs.ask.show({title: `Удалить мероприятие ${event.name}?`}).then(async () => {
            await this.$api.events.remove(event.id);
            this.$store.dispatch('alerts/success', {text: `Мероприятие # ${event.id} удалено`})
            await this.paginate(this.events.current_page)

          })
          break;
        case 'publish':
          this.$refs.ask.show({
            title: 'Вы хотите опубликовать мероприятие?',
            text: 'Убедитесь, что вы внесли все необходимые данные, после публикации мероприятие отобразиться у всех кураторов.'
          }).then(async () => {
            await this.$api.events.publish(event.id);
            await this.paginate(this.events.current_page)
          })
          break;
      }

    }
  },
  watch: {
    queryStr(v) {
      this.paginate(1)
      console.log(v);
    }
  },
  mounted() {
    //this.paginate(1);
  }
}
</script>

<style scoped lang="scss">
.status-tab {
  @apply border-transparent text-gray-500 whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm;
  &:hover {
    @apply text-gray-700 border-gray-300;
  }

  &.active {
    @apply border-orange-500 text-orange-600;
  }
}
</style>